import { createFileRoute } from '@tanstack/react-router';

import { getBookOptions } from '@/module/Author/Book';

export const Route = createFileRoute('/_auth/author/_author/book/_book/$bookId/_layout')({
  loader: async ({ params: { bookId }, context: { queryClient } }) => {
    const book = await queryClient.ensureQueryData(getBookOptions(bookId));

    return {
      book,
      crumb: book.title,
    };
  },
});
